import React from 'react';
import {
  StyledMainProductPlaceholder,
  StyledOfferSection,
  StyledOfferTitle,
} from './style';
import { MainProductData } from '../../../Bundles/types';
import { ProductMadnessSpecialOfferMainProduct as MainProduct } from '../Products/main';
import { Gradient } from '../../../Helper/types';

interface IProductMadnessOfferSection {
  text: string;
  textColor: Gradient;
  fontSize: number;
  mainProduct: MainProductData | null;
  PriceComponent: () => JSX.Element;
}

export const ProductMadnessOfferSection: React.FC<
  IProductMadnessOfferSection
> = ({ text, textColor, fontSize, mainProduct, PriceComponent }) => {
  return (
    <StyledOfferSection>
      <StyledOfferTitle title={text} textColor={textColor} fontSize={fontSize}>
        {text}
      </StyledOfferTitle>
      {mainProduct ? (
        <MainProduct
          quantityDisplay={mainProduct.quantityDisplay}
          images={mainProduct.images}
        />
      ) : (
        <StyledMainProductPlaceholder />
      )}
      <PriceComponent />
    </StyledOfferSection>
  );
};
